export default {
	FILTERS: 'filters',
	CUSTOM: 'custom',
	DATE: 'date',
	DATE_RANGE: 'date_range',
	DATE_WITH_TIMESTAMP: 'date with timestamp',
};
